export const menuItems = [
    {
        id: 1,
        label: "menuitems.dashboards.text",
        icon: "bx-home-circle",
        link: "DashBoard",
    },
    {
        id: 4,
        label: "menuitems.ops.text",
        icon: "bx-grid-alt",
        subItems: [
            {
                id: 5,
                label: "menuitems.ops.list.engagements",
                link: "Engagements",
                parentId: 4,
            },
        ],
    },
    {
        id: 6,
        label: "menuitems.tools.text",
        icon: "bx-grid-alt",
        subItems: [
            {
                id: 7,
                label: "menuitems.tools.list.clockwork",
                link: "ClockWork",
                parentId: 6,
            },
        ],
    },
];
